import React from 'react';
import { Checkbox, RaisedButton } from 'material-ui';

/**
 * @param {{ 
 *  type?: string, 
 *  isLoading: boolean, 
 *  onFetch: Function,
 *  onToggleShowUsefulLines: Function,
 * }} props 
 * @returns 
 */
function PredictorType({
    isLoading, onFetch, type, onToggleShowUsefulLines, 
}) {
    return (
        <div style={{ 
            display: 'inline-flex',
            alignItems: 'center',
            padding: '0px 7px',
            borderRadius: '8px',
            gap: '10px',
            backgroundColor: '#f5f5f5',
            border: '1px solid #e0e0e0',
        }}
        >
            <RaisedButton 
                className='btn'
                labelStyle={{ fontSize: '10px', color: 'white' }}
                style={{ height: '25px', margin: '10px 0' }}
                buttonStyle={{ height: '25px', lineHeight: '25px', backgroundColor: '#B26E63' }}
                label='Predictor type'
                onClick={onFetch}
                disabled={isLoading}
            />
            <span style={{ fontWeight: 'bold' }}>{type}</span>
            {
                type && type !== 'Error' ?
                    <Checkbox 
                        label='Show useful lines' 
                        onCheck={onToggleShowUsefulLines}
                        style={{ width: 'auto', display: 'inline-block', fontSize: '13px' }}
                        labelStyle={{ width: '120px' }}
                        iconStyle={{ marginRight: '5px' }}
                    />
                    : null
            }
        </div>
    );
}

export default PredictorType;


/**
 * @typedef {Object} MailData
 * @property {string} _id
 * @property {string} text
 * @property {string} owner
 */



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/PredictorType.jsx